import { Component, OnInit } from '@angular/core';
import { StoreDataService } from '@common/services/store-data.service';
import { ActivatedRoute } from '@angular/router';

import { Profile } from '@common/models/profile.model';
import { URL_CONFIG } from '@constants/locations.constants';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
    locationName = '';
    locationPhone = '';
    locationState = '';
    logoUrl!: string;
    country!: string;

    constructor (
        private storeDataService: StoreDataService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            if (Object.keys(params).length > 0 && (params['locationName'] || params['state'] || params['locationPhone'] || params['locationState'])) {
                params['locationName'] ? this.locationName = params['locationName'].replace(/merry maids of /i, '') : this.locationName = '';
                params['locationPhone'] ? this.locationPhone = this.phoneFormatter(params['locationPhone']) : this.locationPhone = '';
                if (params['locationState']) {
                    this.locationState = params['locationState'];
                }
            } else {
                this.storeDataService.profileObserver().subscribe((profile: Profile) => {
                    this.locationName = profile.locationName || '';
                    if (profile.locationPhone) {
                        this.locationPhone = this.phoneFormatter(profile.locationPhone);
                    }
                    if (profile.locationState) {
                        this.locationState = profile.locationState;
                    } else {
                        this.locationState = '';
                    }
                    this.country = profile.country ? profile.country : 'US';
                    this.logoUrl = profile.localSiteUrl && this.country === 'Canada' ? profile.localSiteUrl : URL_CONFIG[this.country].LOCAL_SITE;
                })
            }
        });
    }

    phoneFormatter(phone: string): string {
        return `${phone.slice(0, 3)}.${phone.slice(3, 6)}.${phone.slice(6, 10)}`;
    }
}
